import PropTypes from 'prop-types';

// There are places that use the whole filter state as a prop so here we provide convenience and prevent having to
// copy it all over the place. Changes can be made just here.
export default {
    isVisible: PropTypes.bool.isRequired,
    values: PropTypes.objectOf(
        PropTypes.oneOfType([
            // Custom filters
            PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
            // rest of filters
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
    ),
    options: PropTypes.objectOf(
        PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.number),
            PropTypes.arrayOf(PropTypes.string),
            // Ranges
            PropTypes.objectOf(PropTypes.number),
            // States and provinces
            PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        ]),
    ),
};
